export default "__VITE_ASSET__CHurFo38__"